import { render, staticRenderFns } from "./view-MT5-phone.vue?vue&type=template&id=02dcb6a4&scoped=true&"
import script from "./view-MT5-phone.vue?vue&type=script&lang=js&"
export * from "./view-MT5-phone.vue?vue&type=script&lang=js&"
import style0 from "./view-MT5-phone.vue?vue&type=style&index=0&id=02dcb6a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dcb6a4",
  null
  
)

export default component.exports